<template lang="pug">
  div
    collection-profile.my-4(:loyaltySystem="loyaltySystem" :member-id="profile.id" :name="profile.name" :phone="profile.phone" :email="profile.email" :dob="profile.dob" :total-spend="profile.total_spend" :value-collected="profile.collected")
    v-divider.mt-2
    div.text-sm.font-semibold.neutral700--text.mt-6 Purchased value (optional)
    v-text-field.text-sm.mt-2.round-xl(:value="purchasedValue" placeholder="Enter purchased value here" outlined dense height="48" hide-details="auto" :prefix="$currency.symbol" type="number" @input="updatePurchasedValue($event)")
    stamp-to-collect.mt-10(v-if="loyaltySystem === 'stamps'" :value="collectValue" :value-collected="profile.collected" @input="$emit('update:collectValue', $event)")
    v-text-field.text-sm.mt-2.round-xl(v-else :value="collectValue" outlined dense height="48" hide-details="auto" suffix="points" type="number" :loading="isFetching" @change="$emit('update:collectValue', $event)")
</template>

<script>
import CollectionProfile from "@/components/marketing/merchantapp/collect/CollectionProfile.vue";
import StampToCollect from "@/components/marketing/merchantapp/stamps/StampToCollect.vue";
import {mapActions, mapGetters} from "vuex";

export default {
  components: {
    StampToCollect,
    CollectionProfile
  },
  props: {
    loyaltySystem: {
      type: String,
      required: true
    },
    profile: {
      type: Object,
      required: true
    },
    purchasedValue: {
      type: Number,
      default: null
    },
    collectValue: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      isLoading: false,
      isFetching: false,
      pointsEarned: null,
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
  },
  mounted() {
    this.fetchLoyaltySettings()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchLoyaltySettings () {
      if (this.loyaltySystem !== 'points') {
        return
      }
      this.isFetching = true
      let params = {
        fields: 'points_earned'
      }
      this.$axios.get(`/loyalty/${this.company.slug}`, { params })
        .then(resp => {
          this.pointsEarned = resp.data.points_earned
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    updatePurchasedValue(value) {
      this.$emit('update:purchasedValue', value);
      if (this.loyaltySystem === 'points') {
        let collectValue = Math.ceil(value * this.pointsEarned)
        this.$emit('update:collectValue', collectValue)
      }
    },
  },
}
</script>

<style scoped>
</style>
